import React from "react";
import dynamic from "next/dynamic";
import { Container, ButtonsContainer, RichTextWrapper } from "./styles";
import ParagraphTitle from "./ParagraphTitle";

// General components
const ButtonComplex = dynamic(
  () => import("@/components/ButtonComplex")
) as any;
const Accordion = dynamic(() => import("./Accordion")) as any;
const SimpleRichText = dynamic(
  () => import("@/components/SimpleRichText")
) as any;
const Spacer = dynamic(() => import("@/components/Spacer")) as any;
const ParagraphTitleComponent = ParagraphTitle as any;

const Block = (props: any): React.ReactElement | null => {
  switch (props._type) {
    case "button":
      return (
        <ButtonsContainer>
          {props.buttons?.map((button: any) => (
            <ButtonComplex key={button._key} {...button} />
          ))}
        </ButtonsContainer>
      );
    case "paragraphTitle":
      return <ParagraphTitleComponent {...props} />;
    case "accordion":
      return <Accordion {...props} />;
    case "spacer":
      return <Spacer {...props} />;
    case "richText":
      return (
        <RichTextWrapper>
          <SimpleRichText {...props} />
        </RichTextWrapper>
      );
    default:
      return null;
  }
};

export type PageBuilderProps = {
  hasIndex: boolean;
  blocks: any[];
  onParagraphEntry: (id: string) => void;
};

const PageBuilder: React.FC<PageBuilderProps> = ({
  blocks,
  onParagraphEntry,
  hasIndex,
}) => {
  return (
    <Container>
      {blocks?.map((block: any) => {
        if (!block._key) return null;
        const BlockComponent = Block as any;
        return (
          <BlockComponent
            key={block._key}
            hasIndex={hasIndex}
            {...block}
            onParagraphEntry={onParagraphEntry}
          />
        );
      })}
    </Container>
  );
};

export default PageBuilder;
